import { render, staticRenderFns } from "./DmhFaqs.vue?vue&type=template&id=114beb9b"
import script from "./DmhFaqs.vue?vue&type=script&lang=js"
export * from "./DmhFaqs.vue?vue&type=script&lang=js"
import style0 from "./DmhFaqs.vue?vue&type=style&index=0&id=114beb9b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports